import React from 'react';
import { ContentTile, ContentTileProps } from '../contentTile/ContentTile';
import { ContentfulHeading } from '../contentfulHeading';
import styled from 'styled-components';
import { breakpoint, theme } from '../../theme';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${theme.spacings[4.5].px};
`;

const TileWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  border-top: 1px solid ${theme.colors.neutrals.solidGrays[6]};
  align-items: center;
  ${breakpoint('lg')<{ numberOfTiles: number }>`
    flex-wrap:${({ numberOfTiles }) =>
      numberOfTiles <= 5 ? 'nowrap' : 'wrap'};
`}
`;

export type ContentTileContainerProps = {
  contentHeading: {
    heading: string | number;
    subHeading: string | number;
  };
  contentTilesCollection: {
    items: {
      openInNewTab: boolean;
      urlLink: string;
      image: { url: string };
      text?: string | number;
      altText: string;
    }[];
  };
};
export const ContentTileContainer: React.FC<ContentTileContainerProps> = ({
  contentTilesCollection,
  contentHeading,
}: ContentTileContainerProps): JSX.Element => {
  const tileData: ContentTileProps[] = contentTilesCollection?.items
    ?.filter((v) => v !== null)
    .map((data) => ({
      openInNewTab: data.openInNewTab,
      link: data?.urlLink,
      image: data?.image?.url,
      text: data?.text,
      altText: data?.altText,
    }));

  const numberOfTiles = contentTilesCollection?.items?.length;
  return (
    <>
      {tileData && (
        <Wrapper>
          {contentHeading && (
            <ContentfulHeading
              heading={contentHeading?.heading}
              subHeading={contentHeading?.subHeading}
            />
          )}

          <TileWrapper numberOfTiles={numberOfTiles}>
            {tileData.map((item: ContentTileProps) => (
              <ContentTile
                link={item.link}
                openInNewTab={item.openInNewTab}
                image={item.image}
                text={item.text}
                altText={item.altText}
                totalTiles={numberOfTiles}
              />
            ))}
          </TileWrapper>
        </Wrapper>
      )}
    </>
  );
};
